import React from 'react';
import Input from 'react-toolbox/lib/input';
import { Card, CardText, CardActions } from 'react-toolbox/lib/card';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';

import { createUser } from '~/actions/user';

import Styles from './users.scss';

class CreateUser extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = { username: '', password: '', name: '' };
  }

  create() {
    const { username, password, name } = this.state;
    createUser(
      this.props.dispatch,
      this.context.apiClient,
      username,
      password,
      name
    )
      .then(() => {
        this.props.done();
      })
      .catch(e => {
        console.log(e);
      });
  }
  render() {
    return (
      <div
        className={[Styles.cardBox, Styles[this.props.transition]].join(' ')}
      >
        <Card>
          <div className={Styles.orderTitle}>Create user</div>
          <CardText>
            <Input
              type="text"
              label="Username"
              value={this.state.username}
              onChange={e => this.setState({ username: e })}
            />
            <Input
              type="password"
              label="Password"
              value={this.state.password}
              onChange={e => this.setState({ password: e })}
            />
            <Input
              type="text"
              label="Name"
              value={this.state.name}
              onChange={e => this.setState({ name: e })}
            />
          </CardText>
          <CardActions>
            <Button
              label="Create"
              onClick={() => {
                this.create();
              }}
            />
          </CardActions>
        </Card>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  users: state.getIn(['user', 'users'], {})
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(
  CreateUser
);



// WEBPACK FOOTER //
// ./app/pages/Admin/create.js